import fetch from '../../common/services/api/fetch';

export default function addPinnedExtension(urlName) {
    return fetch(
        `/ui/users/preferences/pinned_extensions/add?url_name=${encodeURIComponent(urlName)}`,
        {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
        },
    );
}
